import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CustomError } from 'types';
import { closeModal, openModal } from './modalReducer';
import { getEamEfaDashboardData } from '../services/eam-efa-dashboard/getEamEfaDashboardData';

export type EamEfaDashboardUrls = {
  info: {
    url: string;
  };
};

export const initialEamEfaDashboardState: EamEfaDashboardUrls = {
  info: {
    url: '',
  },
};

export const fetchEamEfaDashboardUrlsData = createAsyncThunk(
  'EAM_EFA_DASHBOARD/fetchEamEfaDashboardUrlData',
  async (partnerNumber: string, thunkAPI) => {
    try {
      const data = await getEamEfaDashboardData(partnerNumber);
      thunkAPI.dispatch(setEamEfaDashboardUrls({ info: data }));
      return;
    } catch (err: unknown) {
      thunkAPI.dispatch(
        openModal({
          modalType: 'JBErrorModalWrapper',
          modalProps: {
            httpError: err,
            okHandler: () => {
              thunkAPI.dispatch(closeModal());
            },
            technicalInfo: {
              title: 'Error when retrieving EAM/EFA Dashboard information',
              userErrorMessage:
                'An error occurred when retrieving EAM/EFA Dashboard information. Please try again later.',
            },
          },
        }),
      );
      return 'error';
    }
  },
);

const eamEfaDashboardUrlsSlice = createSlice({
  name: 'EAM_EFA_DASHBOARD_URL',
  initialState: initialEamEfaDashboardState,
  reducers: {
    setEamEfaDashboardUrls: (state, action: PayloadAction<EamEfaDashboardUrls>) => {
      return { ...state, ...action.payload };
    },
    setEamEfaDashboardUrlsError: (state, action: PayloadAction<CustomError | undefined>) => {
      return { ...state, error: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEamEfaDashboardUrlsData.pending, (state) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(fetchEamEfaDashboardUrlsData.rejected, (state, action) => {
      return { ...state, error: action.payload as CustomError };
    });
    builder.addCase(fetchEamEfaDashboardUrlsData.fulfilled, (state) => {
      return { ...state, isLoading: false };
    });
  },
});

export const { setEamEfaDashboardUrls, setEamEfaDashboardUrlsError } = eamEfaDashboardUrlsSlice.actions;
export default eamEfaDashboardUrlsSlice.reducer;
